import React from 'react'
import { Typography } from '@mui/material'

import { ProductsColumnType } from '../productsDataGridColumns'

export const companyColumnModel: ProductsColumnType = {
  field: 'company',
  width: 125,
  valueGetter: (params) => params.row.company.name,
  renderCell: (params) => (
    <Typography variant="subtitle1" fontWeight={500}>{params.row.company.name}</Typography>
  )
}
